import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from './localization.service';
import { Locales } from './locales';

export interface City {
  name: string;
  nameEn: string;
}

@Pipe({
  name: 'mtgCityName',
})
export class CityNamePipe implements PipeTransform {
  constructor(
    private localizationService: LocalizationService,
  ) {
  }

  transform(value: City): any {
    if (this.localizationService.getLocale() === Locales.en) {
      return value.nameEn;
    }
    return value.name;
  }
}
